<template>
  <!-- 通报批评扣分详情 -->
  <div class="deduct_detail">
    <div class="head">
      <div class="head_left">
        <div  class="head_title">{{ noticeDesc.punishTypeCN }}</div>
        
        <div class="tags">
          <span>{{noticeDesc.areaName}}</span>
          <!-- <span>{{noticeDesc.areaType === 1 ? '一类地区' : '二类地区'}}</span> -->
        </div>
        <div class="time">{{noticeDesc.monitorDate}}</div>
      </div>
      <div class="head_right">
        <div v-if="noticeDesc.audited === 0" class="status">未审核</div>
        <div v-else class="deduct_score">{{deduction}}</div>
        <!-- <div class="percent">{{score}}/{{sumScore}}</div> -->
      </div>
    </div>
    <div class="content">
      <div class="happend_time" v-if=" noticeDesc.audited === 1">
        <div class="tit">受处理原因</div>
        <!-- <div class="desc more_desc_yuanyin">{{noticeDesc.punishReason}}</div> -->
        <div
          class="desc more_desc"
          ref="showMoreDesc"
          :class="{ show_more: showMoreDesc }"
        >{{ noticeDesc.punishReason }}</div>
        <div class="open_more" v-show="oprate_dom_desc">
          <span v-show="showMoreDesc" @click="openMore('Desc')">展开</span>
          <span v-show="!showMoreDesc" @click="openMore('Desc')">收起</span>
          <i v-show="showMoreDesc" class="drop_down"></i>
          <i v-show="!showMoreDesc" class="drop_up"></i>
        </div>
      </div>
      <div class="happend_time">
        <div class="tit">受处理时间</div>
        <div class="desc">{{punishTime}}</div>
      </div>
      <div class="deal_desc">
        <div class="tit">受处理内容</div>
        <!-- <div class="desc">{{noticeDesc.punishDesc}}</div> -->
        <div
          class="desc more_desc"
          ref="showMore"
          :class="{ show_more: showMore }"
        >{{ noticeDesc.punishDesc }}</div>
        <div class="open_more" v-show="oprate_dom">
          <span v-show="showMore" @click="openMore">展开</span>
          <span v-show="!showMore" @click="openMore">收起</span>
          <i v-show="showMore" class="drop_down"></i>
          <i v-show="!showMore" class="drop_up"></i>
        </div>
      </div>
      <div class="related_file">
        <div class="file_title">相关材料</div>
        <div class="file_item" v-for="item in noticeDesc.fileResVOS" :key="item.id">
          <div class="file_msg" @click="openFile(item)">
            <img v-if="item.fileType ==='exl'" src="@/assets/appraise/ic_exl.png" alt />
            <img v-if="item.fileType ==='doc'" src="@/assets/appraise/ic_doc.png" alt />
            <img v-if="item.fileType ==='pdf'" src="@/assets/appraise/ic_pdf.png" alt />
            <p class="file_name">
              <span>{{ item.fileName }}{{'.'+item.fileType}}</span>
            </p>
          </div>
          <div class="file_size">{{item.fileSize}}</div>
        </div>
      </div>
    </div>
    <div class="bot_btn">
      <btnauth custype="apply" :year="year" :quarter="quarter">
        <div class="opreate">
          <div
            class="delete_btn"
            @click="deleteSituation"
            v-if=" deleteAuth === 'OPERATION03' && noticeDesc.audited === 0 "
          >
            <img src="@/assets/appraise/delete.png" alt />
            <span class>删除</span>
          </div>
          <div
            class="edit_btn"
            @click="editSituation"
            v-if=" updateAuth === 'OPERATION02' && noticeDesc.audited === 0 "
          >
            <img src="@/assets/appraise/Group 2@2x.png" alt />
            <span>编辑</span>
          </div>

          <!-- <div
            class="edit_btn"
            @click="editSituation"
          >
            <img src="@/assets/appraise/Group 2@2x.png" alt />
            <span>编辑</span>
          </div>-->
        </div>
      </btnauth>
      <btnauth custype="audit" :year="year" :quarter="quarter">
        <div
          class="check_btn"
          v-if=" userAuthoirese === 'OPERATION06' && noticeDesc.audited === 0 "
        >
          <van-button @click="check" type="primary">审核</van-button>
        </div>
      </btnauth>
    </div>

    <!-- <van-button @click="check" type="primary">审核</van-button> -->

    <titleDialog
      v-if="showDialog"
      :title="dialogTitle"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></titleDialog>
    <modalIframe :url="iframeurl"></modalIframe>
  </div>
</template>

<script>
import titleDialog from "../components/titleDialog.vue";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import api from "@/service/modules/appraiseNew.js";
import btnauth from "../appraiseNew/components/btnauth";
import modalIframe from "../appraiseNew/components/modalIframe";
export default {
  components: {
    titleDialog,
    btnauth,
    modalIframe
  },
  data() {
    return {
      showDialog: false,
      showMore: true,
      showMoreDesc: true,
      oprate_dom: true,
      oprate_dom_desc: true,
      dialogTitle: "",
      cancelBtn: "",
      confirmBtn: "",
      noticeDesc: {}, //  详情数据
      punishTime: "",
      deduction: 0,
      score: 0,
      sumScore: 0,
      // 3个操作权限
      userAuthoirese: this.$route.query.userAuthoirese,
      updateAuth: this.$route.query.updateAuth,
      deleteAuth: this.$route.query.deleteAuth,
      accidentListAuth: this.$route.query.accidentListAuth,
      meetListAuth: this.$route.query.meetListAuth,
      abarbeitungListAuth: this.$route.query.abarbeitungListAuth,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      iframeurl: ""
    };
  },
  created() {
    this.queryDetail();
  },
  updated() {
    this.$nextTick(() => {
      if (this.noticeDesc.punishDesc&&this.noticeDesc.punishDesc.length < 120) {
        this.oprate_dom = false;
      }
      if (this.noticeDesc.punishReason&&this.noticeDesc.punishReason.length < 120) {
              this.oprate_dom_desc = false;
            }
    });
  },
  methods: {
    // 获取详情内容
    queryDetail() {
      let params = {
        id: this.$route.query.id
      };
      api.getNoticeDetail(params).then(res => {
        console.log("----详情页数据:", res);
        ///-------这个位置 需要有 权限判断。
        if (res.ret === 0) {
          this.noticeDesc = res.data;
          this.deduction =
            res.data.deduction === null
              ? 0
              : "-" + (res.data.deduction / 100).toFixed(2);
          this.score = ((1000 - res.data.deduction) / 100).toFixed(2);
          this.sumScore = 10;
          this.punishTime =
            res.data.punishTime.split("-")[0] +
            "年" +
            res.data.punishTime.split("-")[1] +
            "月" +
            res.data.punishTime.split("-")[2] +
            "日";
        }
      });
    },
    // 审核
    check() {
      const { area, year, quarter } = this.$route.query;
      this.$router.push(
        `/appraise/checkSituationNotifi?id=${this.noticeDesc.id}&area=${area}&year=${year}&quarter=${quarter}&accidentListAuth=${this.accidentListAuth}&meetListAuth=${this.meetListAuth}&abarbeitungListAuth=${this.abarbeitungListAuth}`
      );
    },
    // 删除情况
    deleteSituation() {
      (this.dialogTitle = "是否确定删除"),
        (this.cancelBtn = "取消"),
        (this.confirmBtn = "删除"),
        (this.showDialog = true);
    },
    // 编辑
    editSituation() {
      const { area, year, quarter } = this.$route.query;
      this.$router.push({
        path: "/appraise/notificationAdd",
        query: {
          id: this.noticeDesc.id,
          area: area,
          year: year,
          quarter: quarter,
          accidentListAuth: this.accidentListAuth,
          meetListAuth: this.meetListAuth,
          abarbeitungListAuth: this.abarbeitungListAuth
        }
      });
      // this.$router.push(
      //   `/appraise/notificationAdd?id=${this.noticeDesc.id}&area=${area}&year=${year}&quarter=${quarter}`
      // );
    },
    // 弹窗确认回调
    confirm() {
      const { area, year, quarter } = this.$route.query;
      this.showDialog = false;
      let params = {
        id: this.$route.query.id
      };
      api.leaderNoticeDel(params).then(res => {
        if (res.ret === 0) {
          this.$Toast({
            message: "删除成功",
            icon
          });
          setTimeout(() => {
            // this.$router.replace(
            //   `/appraise/notificationList?area=${area}&year=${year}&quarter=${quarter}`
            // );
            this.$router.back(-1);
          }, 2000);
        }
      });
    },
    /**
     * @description: 打开附件
     * @param { item } object
     */
    openFile(item) {
      const _this = this;
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (!ver) {
        console.log("---安卓进来这里url:", item.fileUrl);
        // this.$toast('当前暂不支持预览附件')
        // console.log('不是苹果')
        // this.$router.push({
        //   path: "/appraise/iframepdf",
        //   query: { url: item.fileUrl },
        // });
        this.iframeurl = item.fileUrl;
      } else {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: item.fileUrl,
            isFullScreen: 0,
            setTitle: name,
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      }
       setTimeout( ()=>{
        _this.iframeurl = ''
      }, 100)
    },
    openMore(type) {
      type = typeof type == "object" ? "" : type;
      this[`showMore${type}`] = !this[`showMore${type}`];
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    }
  }
};
</script>

<style scoped lang="less">
.deduct_detail {
  padding-bottom: 60px;
  .head {
    display: flex;
    justify-content: space-between;
    padding: 0 12px;
    width: 100%;
    height: 110px;
    border-bottom: 1px solid #eee;
  }
  .head_left {
    .head_title {
      margin: 24px 0 12px;
      color: #333;
      font-size: 20px;
      font-weight: bold;
    }
    .tags span {
      display: inline-block;
      margin-right: 9px;
      padding: 1px 4px;
      font-size: 10px;
      line-height: 14px;
      color: #36b374;
      border: 1px solid #36b374;
    }
    .time {
      margin-top: 12px;
      font-size: 12px;
      color: #999;
    }
  }
  .head_right {
    padding-top: 22px;
    .deduct_score {
      font-size: 22px;
      font-weight: 500;
      color: #ff4d4d;
      text-align: right;
    }
    .percent {
      margin: 8px 0 16px;
      color: #999;
      font-size: 14px;
      font-weight: 500;
    }
    .status {
      margin-left: 9px;
      font-size: 14px;
      color: #ff8c19;
    }
  }
  .content {
    .deduct_reason,
    .happend_time {
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      color: #333;
      .tit {
        padding: 15px 0 14px;
        font-size: 16px;
        font-weight: bold;
      }
      .desc {
        padding-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .deal_desc {
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      // color: #333;
      .tit {
        padding: 15px 0 14px;
        font-size: 16px;
        font-weight: bold;
      }
      .desc {
        padding-bottom: 10px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
      }
    }
  }
  .related_file {
    padding: 0 12px;
    .file_title {
      padding: 15px 0 16px;
      font-size: 16px;
      font-weight: bold;
      // color: #333;
    }
    .file_item {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      .file_msg {
        flex: 1;
        display: flex;
        align-items: center;
      }
      .file_msg img {
        margin-right: 12px;
        width: 34px;
        height: 38px;
      }
      .file_msg p {
        font-size: 14px;
        color: #333;
        word-break: break-all;
        span {
          line-height: 20px;
          word-break: break-word;
        }
      }
      .file_size {
        font-size: 12px;
        color: #999;
      }
      .delImg {
        box-sizing: border-box;
        line-height: 38px;
        margin-left: 5px;
        margin-right: 10px;
      }
      .delImg img {
        width: 15px;
        height: 16px;
      }
    }
  }
  .bot_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
    .opreate {
      padding: 12px 0;
      div {
        display: inline-block;
      }
    }
    .delete_btn {
      margin-right: 24px;
    }
    img {
      display: inline-block;
      margin-right: 4px;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      font-size: 16px;
      color: #36b374;
      vertical-align: middle;
    }
  }
  .check_btn .van-button {
    width: 203px;
    height: 40px;
    border-radius: 3px;
    background-color: #36b374;
    span {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
.more_desc_yuanyin {
  line-height: 18px;
}
.more_desc {
  margin-bottom: 10px;
  padding-bottom: 0 !important;
  display: inline-block;
  line-height: 22px;
}
.show_more {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-emphasis: ellipsis;
}
.open_more {
        padding-bottom: 16px;
        text-align: center;
        span {
          margin-right: 5px;
          font-size: 14px;
          color: #666;
        }
        .drop_down {
          display: inline-block;
          width: 0;
          height: 0;
          border: 4px solid #9b9b9b;
          border-left-color: transparent;
          border-right-color: transparent;
          border-bottom-color: transparent;
        }
        .drop_up {
          display: inline-block;
          width: 0;
          height: 0;
          border: 4px solid #9b9b9b;
          border-left-color: transparent;
          border-right-color: transparent;
          border-top-color: transparent;
        }
      }
</style>